import { render, staticRenderFns } from "./ngo-admin-project-list.vue?vue&type=template&id=cc7d6134&scoped=true&"
import script from "./ngo-admin-project-list.vue?vue&type=script&lang=js&"
export * from "./ngo-admin-project-list.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin-project-list.vue?vue&type=style&index=0&id=cc7d6134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7d6134",
  null
  
)

export default component.exports